import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ResetPasswordService } from './reset-password.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../shared/alerts/alerts.service';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'reset-password',
  template: require('./reset-password.component.html'),
  styles: [require('./reset-password.component.scss'), require('../shared/styles/form.scss')],
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  stateToken = '';

  constructor(private fb: FormBuilder, 
            private resetPasswordService: ResetPasswordService,
            private route: ActivatedRoute,
            private alertService: AlertService,
            private router: Router) {}

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const url = params.get('url');
    if (url) {
        const arr = url.split('/');
        const token = arr[arr.length-1];
    
        if (token) {
            this.getStateToken(token);
        }
    }
    
    this.resetPasswordForm = this.fb.group(
      {
        newPassword: ['', [
            Validators.required,
            Validators.minLength(16),
            Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/)
          ]],
        repeatPassword: ['', [Validators.required]],
        // signOutAllDevices: [false],
      },
      {
        validator: [this.passwordMatchValidator('newPassword', 'repeatPassword')],
        updateOn: 'change',
      }
    );

    // Trim spaces in the newPassword field
    this.resetPasswordForm.get('newPassword').valueChanges.pipe(debounceTime(500)).subscribe(value => {
      if (value) {
          const trimmedValue = value.trim();
          if (value !== trimmedValue) {
              this.resetPasswordForm.get('newPassword').setValue(trimmedValue, { emitEvent: false });
          }
      }
    });
  }

  getStateToken(token) {
    let param = {
        recoveryToken: token
    }
    this.resetPasswordService.getStateToken(param).subscribe(data => {
        this.stateToken = data.stateToken;
    }, (error) => {
        this.error(error);
    });
  }

  error(error: any): any {
    let data;
    try {
      data = JSON.parse(error._body);
    } catch (e) { }

    let errMsg = '';
    if (data.errorCauses.length > 0) {
      errMsg = data.errorCauses[0].errorSummary;
    } else {
      errMsg = data.errorSummary;
    }
    this.alertService.createAlert(true, true, errMsg);
  }

  isPasswordValid(rule: string): boolean {
    const password = this.resetPasswordForm.get('newPassword').value;
    switch (rule) {
      case 'minLength': return password.length >= 16;
      case 'lowercase': return /[a-z]/.test(password);
      case 'uppercase': return /[A-Z]/.test(password);
      case 'number': return /\d/.test(password);
      case 'symbol': return /[\W_]/.test(password);
      default: return false;
    }
  }

    /**
     * Custom validator to ensure newPassword and repeatPassword match
     */
    passwordMatchValidator(controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (control.value === matchingControl.value) {
                matchingControl.setErrors(null);
            } else {
                matchingControl.setErrors({ mismatch: true });
            }
        };
    }

    onBack() {
        this.router.navigate(['\login']);
    }
  
    /**
     * Handle form submission
     */
    onSubmit() {
      this.resetPasswordForm.markAsTouched();
      if (this.resetPasswordForm.valid) {
          let param = {
              newPassword: this.resetPasswordForm.get('newPassword').value,
              stateToken: this.stateToken
          }
          // if (this.resetPasswordForm.get('signOutAllDevices').value) {
          //     param['revokeSessions'] = true;
          // }
          this.resetPasswordService.resetPassword(param).subscribe(() => {
              this.alertService.createAlert(true, false, 'Password reset was successful');
              // if (param['revokeSessions']) {
              //   this.authService.logout();
              // }
              this.router.navigate(['\login']);
          }, (error) => {
            this.error(error);
          });
      }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reset-password/reset-password.component.ts